import it_IT from 'antd/lib/locale/it_IT';
import saMessages from '../locales/it_IT.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  antd: it_IT,
  locale: 'it-IT',
};
export default saLang;
